export const SET_ALL_MSG = 'SET_ALL_MSG'
export const SET_SOCKET = 'SET_SOCKET'

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const RESET_WEB_SOCKET_STATE = 'RESET_WEB_SOCKET_STATE'
export const RESET_GENERAL_MESSAGES = 'RESET_GENERAL_MESSAGES'
